export const OPEN_NAVIGATION = 'OPEN_NAVIGATION';
export const CLOSE_NAVIGATION = 'CLOSE_NAVIGATION';



/** WEBPACK FOOTER **
 ** ./src/components/redux-constants/action-types.js
 **/